import { Component, inject } from '@angular/core';
import { CreateAufgabeFormService } from '@schir-int-client/aufgabe';
import { CreateVerfuegungFormService } from './create-verfuegung.formservice';
import {
	AufgabeFacade,
	AufgabenTyp,
	aufgabenTypenForRegister,
	AufgabeTypStaticTaetigkeitLabel,
} from '@schir-int-client/aufgabe-shared';
import { BaseEditorComponent } from '@schir-int-client/tech';
import { VerfahrenFacade } from '@schir-int-client/verfahren-shared';
import { filter } from 'rxjs/operators';
import { isNotNullOrUndefined } from '../../../../../tech/src/lib/filter/common';
import { RegisterName } from '@schir-int-client/register-shared';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
	selector: 'schir-int-client-create-verfuegung-dialog',
	templateUrl: './create-verfuegung-dialog.component.html',
	styleUrls: ['./create-verfuegung-dialog.component.scss'],
	providers: [CreateVerfuegungFormService, CreateAufgabeFormService],
	standalone: false,
})
export class CreateVerfuegungDialogComponent extends BaseEditorComponent {
	readonly formService = inject(CreateVerfuegungFormService);
	readonly aufgabeFormService = inject(CreateAufgabeFormService);
	readonly aufgabeFacade = inject(AufgabeFacade);
	readonly verfahrenFacade = inject(VerfahrenFacade);

	readonly aufgabenTypen = AufgabenTyp;
	readonly aufgabeTypStaticTaetigkeitLabel = AufgabeTypStaticTaetigkeitLabel;
	valideAufgabenTypen: Array<AufgabenTyp> = [];
	protected register: RegisterName;

	constructor() {
		super();
		this.verfahrenFacade.verfahrenSingle
			.pipe(
				takeUntilDestroyed(),
				filter(v => isNotNullOrUndefined(v))
			)
			.subscribe(v => {
				this.register = v.register;
				this.valideAufgabenTypen = aufgabenTypenForRegister(v.register, false);
			});
	}

	get form() {
		return this.formService.form;
	}

	isValid(): boolean {
		return this.formService.checkPreconditions();
	}

	async submit(): Promise<boolean> {
		return this.formService.submit();
	}

	protected toggleGroup(aufgabenTyp: AufgabenTyp, enable: boolean) {
		if (enable) {
			this.aufgabeFormService.enableAufgabenTyp(aufgabenTyp);
		} else {
			this.aufgabeFormService.disableAufgabenTyp(aufgabenTyp);
		}
		this.form.markAsDirty();
	}

	protected toggleBescheinigungGroup(enable: boolean) {
		if (enable) {
			this.formService.bescheinigungGroup.enable();
			if (!this.formService.bescheinigungGroup.controls.vorabPerFax.value) {
				this.formService.bescheinigungGroup.controls.faxEmpfaenger.disable();
			}
		} else {
			this.formService.bescheinigungGroup.disable();
		}
	}
}
